export function add(accumulator, a) {
  return accumulator + a;
}
